import React from 'react';

const Progress = ({ value, indeterminate, color = 'var(--accent)', height = 4 }) => (
  <div style={{ width: '100%', height, background: 'var(--line-soft)', borderRadius: 99, overflow: 'hidden', position: 'relative' }}>
    {indeterminate ? (
      <div style={{
        position: 'absolute', height: '100%', width: '40%', background: color, borderRadius: 99,
        animation: 'qBar 1.2s infinite linear',
        transform: 'translateX(-100%)',
      }} />
    ) : (
      <div style={{
        width: `${Math.max(0, Math.min(100, value || 0))}%`, height: '100%', background: color, borderRadius: 99,
        transition: 'width 320ms var(--ease-out)',
      }} />
    )}
  </div>
);

export default Progress;
